import { useTranslation } from 'react-i18next';
import { WebEditPageShell } from '../../../components/cv/WebEditPageShell';
import { EditHeaderForm } from '../../../components/cv/forms/EditHeaderForm';
import { useCVData } from '../../../lib/cv-mock-data';
import { useUpdateProfile } from '../../../hooks/useProfileApi';

export default function EditHeaderWebScreen() {
  const { t } = useTranslation('seeker');
  const { profileRef } = useCVData();
  const updateProfile = useUpdateProfile();

  const handleSave = async () => {
    const p = profileRef.current;
    await updateProfile.mutateAsync({
      name: p.name,
      headline: p.headline,
      location: p.location,
      contactEmail: p.contactEmail,
      phone: p.phone,
      avatarUrl: p.avatarUrl || null,
      linkedin: p.linkedin,
      website: p.website,
      github: p.github,
      dribbble: p.dribbble,
      behance: p.behance,
    });
  };

  return (
    <WebEditPageShell title={t('cv.edit.headerContact')}>
      <EditHeaderForm onSave={handleSave} />
    </WebEditPageShell>
  );
}
